import React from "react";
import { hydrate, render } from "react-dom";

//import { render } from 'react-snapshot';

import unregister from "./registerServiceWorker";
import registerServiceWorker from "./registerServiceWorker";
import { BrowserRouter } from "react-router-dom";
import makeRoutes from "./routes";
import Root from "./containers/Root";
import configureStore from "./redux/configureStore";
import "babel-polyfill";
import fetch from "isomorphic-fetch";
import browser from "detect-browser";

import "bootstrap/dist/css/bootstrap.css";
//import 'bootstrap/dist/css/bootstrap-theme.css';

import "./styles/core.css";

// const CLIENT_BASE_URL = 'http://localhost:8000'
// const CLIENT_BASE_URL = "http://festadocinemaitaliano.test/admin";
const CLIENT_BASE_URL = "https://festadocinemaitaliano.com/admin";
// const CLIENT_BASE_URL = 'http://tspot.net/admin'
// const CLIENT_BASE_URL = 'http://festadocinemaitaliano.com.br/admin'

let isObsolete = false;
if (browser.name === "ie") {
  const parts = browser.version.split(".");
  if (parts.length) {
    const vers = parseInt(parts[0], 10);
    if (vers <= 9) {
      isObsolete = true;
    }
  }
}

if (isObsolete) {
  document.getElementById("outdated").style.display = "block";
}

unregister();

fetch(`${CLIENT_BASE_URL}/api/homeprefs`)
  .then(req => req.json())
  .then(json => {
    const initialState = json;

    console.log("on init", json);
    // const initialState = window.__INITIAL_STATE__
    const store = configureStore(initialState);

    // Now that we have the Redux store, we can create our routes. We provide
    // the store to the route definitions so that routes have access to it for
    // hooks such as `onEnter`.
    const routes = makeRoutes(store, initialState);

    const rootElement = document.getElementById("root");
    render(<Root routes={routes} store={store} />, rootElement);
  });

/*
const initialState = {
  selectedScope: "festa",
  selectedAgendaColor: "#ec1c24",
  selectedVisibility: {
    festprog: "1",
    movies: "1",
    news: "1"
  }
};

const store = configureStore(initialState);

const routes = makeRoutes(store, initialState);

const rootElement = document.getElementById("root");
render(<Root routes={routes} store={store} />, rootElement);
*/

/*
if (rootElement.hasChildNodes()) {
  hydrate(<Root routes={routes} store={store} />, rootElement);
} else {
  render(<Root routes={routes} store={store} />, rootElement);
}

registerServiceWorker();
*/



// WEBPACK FOOTER //
// ./src/index.js